import { Box } from "theme-ui";

export default function PlusIcon(props) {
  return (
    <Box
      as="svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="13" cy="13" r="12" stroke="#E6E6E6" strokeWidth="2" />
      <path
        d="M8.5 12C7.94772 12 7.5 12.4477 7.5 13C7.5 13.5523 7.94772 14 8.5 14V12ZM17.5 14C18.0523 14 18.5 13.5523 18.5 13C18.5 12.4477 18.0523 12 17.5 12V14ZM14 8.5C14 7.94772 13.5523 7.5 13 7.5C12.4477 7.5 12 7.94772 12 8.5H14ZM12 17.5C12 18.0523 12.4477 18.5 13 18.5C13.5523 18.5 14 18.0523 14 17.5H12ZM8.5 14H17.5V12H8.5V14ZM12 8.5V17.5H14V8.5H12Z"
        fill="#E6E6E6"
      />
    </Box>
  );
}
